import { Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { CellRendererParams } from './types';

const Wrapper = styled(Typography.Text).attrs({
  ellipsis: { tooltip: true },
})`
  width: 100%;
`;

export const PartnerAdminRenderer: FC<CellRendererParams> = ({ value }) => {
  return (
    <Wrapper>
      {(value as User[]).map(({ emailId }) => emailId).join(', ')}
    </Wrapper>
  );
};
